export const SET = "salesOrderDetail/SET";
export const SET_SALES_ORDER_WITH_ALL_LINE_ITEMS =
  "salesOrderWithAllLineItemsDetail/SET";
export const CANCEL_LINE_ITEM = "salesOrderDetail/CANCEL_LINE_ITEM";



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/actionTypes.js